import script from "./ClientPortal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientPortal.vue?vue&type=script&setup=true&lang=ts"

import "./ClientPortal.vue?vue&type=style&index=0&id=6a055b45&lang=scss&scoped=true"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a055b45"]])

export default __exports__